import { requestFromServer } from "./api-client";

const Configs = {
  getAlloweds: () => {
    return requestFromServer(`v1/Config/getAllAllowedList`);
  },
  updateAutoImportEnabled: (value) => {
    return requestFromServer(`v1/Loading_Orders/setImportLoadingOrderDocumentEnabled/${value}`, 'POST');
  },
  isAutoImportEnabled: () => {
    return requestFromServer(`v1/Loading_Orders/isImportLoadingOrderDocumentEnabled`);
  },
  getSchedulingConfigs: () => {
    return requestFromServer('v1/Users_Settings/getSettingsByKey/page_schedulings');
  },
  saveJson: (payload) => {
    return requestFromServer('v1/Users_Settings/saveJson', 'POST', payload);
  }
};

export default Configs;
